// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-df53b3fc"};